export default {
	title: 'Riesgos / Aperturas',
	risks: 'Riesgos',
	opportunities: 'Aperturas',
	url: 'riesgos',
	subtitle: '',
	all_categories: 'Filtro categorías',
	all_impacts: 'Filtro impacto',
	all_likelihoods: 'Filtro probabilidad',
	all_stakeholders: 'Filtro partes interesadas',
	all_stakes: 'Filtro intereses',
	no_stakeholder: 'Sin parte interesada',
	tabs: {
		filters: {
			title: 'Filtros de vista',

			displayed_columns: 'Columnas mostradas',
			visualization_options: 'Opciones de visualización'
		},
		options: {
			title: 'Mostrar',
			are_links_visible: 'Mostrar todos los enlaces',
			show_description: 'Mostrar descripción',
			chart_visible_stakes: 'Mostrar intereses',
			chart_visible_stakeholders: 'Mostrar partes interesadas',
			chart_visible_risks: 'Mostrar riesgos',
			chart_visible_opportunities: 'Mostrar aperturas'
		},
		general: {
			title: 'General'
		},
		stakeholders: {
			title: 'Partes interesadas'
		},
		export: {
			title: 'Exportar'
		},
		comments: {
			title: 'Historial'
		}
	},
	visualization_tab: 'Visualización',
	onboarding: {
		risks: {
			title: 'Revisar los riesgos',
			description:
				'Estos son los riesgos que pesan sobre sus intereses. Evalúe su probabilidad y su impacto, y corrija los que le parezcan mal calibrados.'
		},
		opportunities: {
			title: 'Revisar las aperturas',
			description:
				'A diferencia de los riesgos, las aperturas son dinámicas que pueden fortalecer sus intereses. Conserve las accionables, descarte el resto.'
		}
	}
};
